import "./Industrycentric.scss";
import Grid from "@mui/material/Grid2";
import { useDispatch } from "react-redux";
import { setActiveIndex, show } from "../../redux/SideBarSlice";
import { setNav_Item } from "../../redux/NavBarSlice";
import { Container } from "@mui/material";
import {
  ArrowNarrowRight,
  Banking,
  Education,
  Healthcare,
  RightArrow,
} from "../../helpers/constant/imageUrl";
import { useNavigate } from "react-router-dom";
import {
  openSubMenu,
  setActiveMenu,
  toggleMobileNavbar,
} from "../../redux/MobileSideBar";
import { INDUSTRIES } from "../../page/industries/constant";

const Industrycentric = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <div
      className="industries"
      style={{ background: "white", position: "relative" }}
    >
      <Grid className="orangebox"></Grid>
      <Container className="container">
        <Grid className="headingbox">
          <h4>Industry Centric Salesforce Solutions from Utilitarian Labs </h4>
        </Grid>
        <Grid className="bigbox">
          <Grid
            container
            style={{
              width: "1056px",
              margin: "auto",
              display: "flex",
              justifyContent: "space-around",
              alignitem: "center",
            }}
            class="mob"
          >
            <Grid size={{ xs: 12, md: 3 }}>
              <div className="service-card">
                 <img  loading="lazy" src={Banking}   alt="banking" className="avtar" />
                <h5>Banking & Financial Services (BFSI) </h5>
              
                <p className="service_card_para">
                  Enhance client onboarding, streamline wealth management, and
                  ensure regulatory compliance with a 360-degree view of the
                  customer lifecycle.
                </p>
                <p
                  className="know-more"
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(show("industries"));
                    dispatch(setActiveIndex(0));
                    dispatch(setNav_Item("industries"));

                    //! for mobile
                    dispatch(toggleMobileNavbar());
                    dispatch(setActiveMenu("industries"));
                    dispatch(openSubMenu(INDUSTRIES[0]));
                  }}
                >
                  Know more  <img  loading="lazy" src={RightArrow}   alt="arrow" />
                </p>
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <div className="service-card">
                 <img  loading="lazy" src={Education}   alt="education" className="avtar" />
                <h5>
                  Education & <br /> EdTech{" "}
                </h5>
                <p className="service_card_para">
                  Transform student journeys from admission to alumni, empower
                  faculty, and drive engagement with a connected campus
                  experience.
                </p>
                <p
                  className="know-more"
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(show("industries"));
                    dispatch(setActiveIndex(2));
                    dispatch(setNav_Item("industries"));

                    //! for mobile
                    dispatch(toggleMobileNavbar());
                    dispatch(setActiveMenu("industries"));
                    dispatch(openSubMenu(INDUSTRIES[2]));
                  }}
                >
                  Know more  <img  loading="lazy" src={RightArrow}   alt="arrow" />
                </p>
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <div className="service-card">
                 <img  loading="lazy" src={Healthcare}   alt="healthcare" className="avtar" />
                <h5>
                  Healthcare & Life <br /> Sciences{" "}
                </h5>
                <p className="service_card_para">
                  Improve patient care coordination, manage provider
                  relationships, and accelerate clinical trial management with a
                  unified data platform.
                </p>
                <p
                  className="know-more"
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(show("industries"));
                    dispatch(setActiveIndex(1));
                    dispatch(setNav_Item("industries"));

                    //! for mobile
                    dispatch(toggleMobileNavbar());
                    dispatch(setActiveMenu("industries"));
                    dispatch(openSubMenu(INDUSTRIES[1]));
                  }}
                >
                  Know more  <img  loading="lazy" src={RightArrow}   alt="arrow" />
                </p>
              </div>
            </Grid>

            <Grid size={{ xs: 12, md: 3 }}>
              <p
                className="view-all"
                onClick={(e) => {
                  e.preventDefault();
                  dispatch(show("industries"));
                  dispatch(setNav_Item("industries"));
                  dispatch(setActiveIndex(null));

                  //! for mobile
                  dispatch(toggleMobileNavbar());
                  dispatch(setActiveMenu("industries"));
                }}
                style={{ zIndex: 1 }}
              >
                <span className="span">
                  View all{" "}
                   <img  loading="lazy"
                    src={ArrowNarrowRight}
                     
                    alt="arrow"
                    className="mt-3"
                  />
                </span>
              </p>
            </Grid>
          </Grid>
        </Grid>
        <Grid className="smallcontbox">
          <Grid className="box1">
            <h3>
              Tailored for Your <br /> Industry, Engineered <br />
              for Your Success
            </h3>
          </Grid>
          <Grid className="box2">
            <p>
              Your sector has unique challenges and opportunities. We deliver{" "}
              <br /> Salesforce solutions with deep industry context, ensuring
              the platform <br /> drives meaningful value where it matters most.
            </p>
          </Grid>
        </Grid>
        <Grid className="btnbox">
          <button
            className="btn1"
            onClick={() => {
              dispatch(show("industries"));
              dispatch(setNav_Item("industries"));
              dispatch(setActiveIndex(null));

              //! for mobile
              dispatch(toggleMobileNavbar());
              dispatch(setActiveMenu("industries"));
            }}
          >
            MORE DETAILS
          </button>
          <button className="btn2" onClick={() => navigate("/talktoexpert")}>
            GET EXPERT GUIDANCE
          </button>
        </Grid>
      </Container>
    </div>
  );
};

export default Industrycentric;
